import { EditorState, Plugin } from 'prosemirror-state';
import parseHTML from 'rich-text-lib/utils/parseHTML';
import { convertToPlaintextState, removeNonPlaintextNodes } from '../utils/plaintextUtils';

/**
 * TODO: move this into state for the PasteOverridePlugin
 */
// eslint-disable-next-line no-restricted-syntax
let pasteOverrideConfig;
/**
 * Create a transformer which removes a given CSS rule from any children
 * that have a style attribute.
 *
 * @param styleProperty CSS property to remove from all DOM nodes
 * @returns {PasteTransformer}
 */
const styleTransformer = styleProperty => {
  return htmlEl => {
    if (htmlEl.querySelectorAll('[data-pm-slice]').length === 0) {
      htmlEl.querySelectorAll('[style]').forEach(el => el.style.removeProperty(styleProperty));
    }
    return htmlEl;
  };
};

/**
 * Create a transformer which removes all instances of an HTML element from
 * the children of a DOM node.
 *
 * @param tag Name of an HTML tag to remove
 * @returns {PasteTransformer}
 */
const removeTagTransformer = tag => {
  return htmlEl => {
    if (htmlEl.querySelectorAll('[data-pm-slice]').length === 0) {
      const collection = htmlEl.getElementsByTagName(tag);
      while (collection.length > 0) {
        collection[0].remove();
      }
    }
    return htmlEl;
  };
};
const pasteTransformers = {
  ['stripTextHighlights']: styleTransformer('background-color'),
  ['stripTextColor']: styleTransformer('color'),
  ['stripTextStyle']: styleTransformer('font-family'),
  ['stripTextSize']: styleTransformer('font-size'),
  ['stripImages']: removeTagTransformer('img')
};
export const PasteOverridePlugin = new Plugin({
  state: {
    init() {
      return {};
    },
    apply(tr, currentPluginState) {
      const meta = tr.getMeta(PasteOverridePlugin);
      if (meta) {
        pasteOverrideConfig = meta.pasteOverrideConfig || pasteOverrideConfig;
        return meta;
      }
      return currentPluginState;
    }
  },
  props: {
    transformPastedHTML: html => {
      if (!pasteOverrideConfig) return html;
      let htmlEl = parseHTML(html);
      for (const prop in pasteOverrideConfig) {
        if (pasteOverrideConfig[prop] && pasteTransformers[prop]) {
          htmlEl = pasteTransformers[prop](htmlEl);
        }
      }
      return htmlEl.outerHTML;
    },
    handlePaste: (view, _event, slice) => {
      if (pasteOverrideConfig && pasteOverrideConfig.usePlaintextMode) {
        let sliceState = EditorState.create({
          schema: view.state.schema
        });
        sliceState = sliceState.apply(sliceState.tr.replace(0, undefined, slice));
        view.dispatch(view.state.tr.replaceSelection(removeNonPlaintextNodes(convertToPlaintextState(sliceState, pasteOverrideConfig.plaintextOptions)).doc.slice(0)));
        return true;
      }
      return false;
    }
  }
});